module.exports = __webpack_public_path__ + "static/img/8.74b77ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/8.png
// module id = WG4J
// module chunks = 0